import { clazzAllowUserTypes, ClazzAssessmentAllowSubjects } from '@/common/allow-list'
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import OperationGuide from '../opreation-guide'
@Component({ components: { OperationGuide }})
export default class AssessmentModal extends Vue {
  private visible = false
  private opVisible = false

  private get assessmentModalStatus() {
    return Boolean(this.$store.state.assessmentModalStatus)
  }

  private get userInfo() {
    return this.$store.state.user_info
  }

  private get subjectId() {
    return this.$store.state.subject && this.$store.state.subject.value
  }

  private get title() {
    return this.$store.state.user_info && this.$store.state.user_info.regions && this.$store.state.user_info.regions.length > 0 && this.$store.state.user_info.regions[2].code == 310112 ? '选择练习类型' : '选择测评类型'
  }

  private get clazzModalStatus() {
    if (this.userInfo && clazzAllowUserTypes.indexOf(this.userInfo.user_type) > -1) {
      const arr = this.userInfo.subjects.filter((n) => {
        return ClazzAssessmentAllowSubjects.find((item) => item.value == n[0])
      })
      console.log(arr)
      if (arr && arr.length) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  @Watch('assessmentModalStatus', { deep: true })
  public onAssessmentModalStatusChange(val) {
    this.visible = true
  }

  // 选取校级测评还是班级测评
  public trackSchoolOrClazz(params) {
    window['sensors'].track('TIKU_Assessment_select_Test_Type', params)
  }

  // 关闭弹窗
  public closeModal() {
    this.visible = false
  }
  // 班级测评
  public clazzAssessment() {
    this.closeModal()
    this.trackSchoolOrClazz({
      Assessment_type: '班级测评'
    })
    this.$router.push({ path: '/clazz/lib' })
  }
  // 校级测评
  public schoolAssessment() {
    this.closeModal()
    this.trackSchoolOrClazz({
      Assessment_type: '校级测评'
    })
    this.$router.push({ path: '/assessment/lib' })
  }
  // 了解更多
  public assessmentIntro() {
    this.closeModal()
    this.$router.push({ path: '/assessment/intro' })
  }
  public showIntroVideo() {
    this.opVisible = true
  }
  // cancel
  private cancel() {
    this.opVisible = false
    this.$store.commit('SET_NEW_ASSESSMENTOR', false)
  }
}
